import { useCallback, useRef, useState } from 'react';
import { isMovableEvent } from '../scheduleMove';

/**
 * 주간·월간 보기 일정 드래그 공통 상태 (브라우저 기본 드래그앤드롭 사용). enabled=false 면 끌 수 없다.
 * dragRef 는 dragover 에서 "지금 끄는 것이 일정인지" 즉시 판정하는 용도, dragEvent 는 끄는 카드를 반투명하게 그리는 용도다.
 */
const useScheduleEventDrag = ({ onStart, onEnd, enabled = true } = {}) => {
  const dragRef = useRef(null);
  // 드래그를 시작한 순간의 커서 세로 좌표 — 놓을 때 세로 이동량을 재는 기준이다
  const dragStartYRef = useRef(0);
  const [dragEvent, setDragEvent] = useState(null);

  const endDrag = useCallback(() => {
    dragRef.current = null;
    setDragEvent(null);
  }, []);

  // 카드에 펼쳐 넣을 props — 이동 불가 일정(그룹레슨)은 빈 객체
  const getDragProps = event => {
    // 수정 권한이 없으면 카드를 끌 수 없다
    if (!enabled || !isMovableEvent(event)) return {};
    return {
      draggable: true,
      onDragStart: e => {
        e.stopPropagation();
        dragRef.current = event;
        dragStartYRef.current = e.clientY;
        e.dataTransfer.effectAllowed = 'move';
        // Firefox 는 setData 가 없으면 드래그를 시작하지 않는다
        e.dataTransfer.setData('text/plain', '');
        onStart?.();
        // 드래그 이미지가 만들어진 뒤에 반투명 처리한다
        setTimeout(() => setDragEvent(event), 0);
      },
      onDragEnd: () => {
        endDrag();
        onEnd?.();
      },
    };
  };

  return { dragRef, dragStartYRef, dragEvent, endDrag, getDragProps };
};

export default useScheduleEventDrag;
